import React, { useState } from 'react';

import { useAnimalFilters } from '../../hooks/animalFilters';
import renderAnimalFiltersText from '../../utils/renderAnimalFiltersText';

import { IconFilter, IconX } from '@tabler/icons';
import AnimalFiltersModal from '../AnimalFiltersModal';
import { Container } from './styles';

interface AnimalFiltersButtonProps {
  propertyId: string;
}

const AnimalFiltersButton: React.FC<AnimalFiltersButtonProps> = ({
  propertyId,
  ...rest
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { animalFilters, clearAnimalFilters } = useAnimalFilters();

  return (
    <>
      <Container>
        <button
          className="manage-filters"
          title="Selecionar filtros"
          onClick={() => setIsModalOpen(true)}
        >
          <IconFilter size={24} />
          Filtros
          <span>{renderAnimalFiltersText(animalFilters)}</span>
        </button>

        {animalFilters.sexo ||
        animalFilters.ano ||
        animalFilters.raça ||
        animalFilters.categoria ||
        animalFilters.safra ||
        animalFilters.lote ? (
          <button
            className="clear-filters"
            onClick={clearAnimalFilters}
            title="Limpar filtros"
          >
            <IconX size={18} />
          </button>
        ) : null}
      </Container>

      <AnimalFiltersModal
        propertyId={propertyId}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
};

export default AnimalFiltersButton;
